import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InsightsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"insights"}/>
}
